import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { fetchSystemLinks } from '../services/api';
import { openTelegramAppLink } from '../utils/telegramLinks';

const TelegramModalContext = createContext(null);

export const TelegramModalProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [botLink, setBotLink] = useState('');
    const [actionLabel, setActionLabel] = useState('Открыть Telegram');
    const [isRestrictedRegion, setIsRestrictedRegion] = useState(null);

    useEffect(() => {
        let isMounted = true;

        fetchSystemLinks()
            .then((links) => {
                if (!isMounted) return;
                setIsRestrictedRegion(links.isRestrictedRegion === true);
            })
            .catch(() => {
                if (!isMounted) return;
                setIsRestrictedRegion(null);
            });

        return () => {
            isMounted = false;
        };
    }, []);

    const openTelegramModal = useCallback((link, options = {}) => {
        if (isRestrictedRegion === false) {
            openTelegramAppLink(link || '', { webFallback: true });
            return;
        }

        setBotLink(link || '');
        setActionLabel('Открыть Telegram');
        setIsOpen(true);
    }, [isRestrictedRegion]);

    const closeTelegramModal = useCallback(() => {
        setIsOpen(false);
    }, []);

    return (
        <TelegramModalContext.Provider value={{ isOpen, botLink, actionLabel, isRestrictedRegion, openTelegramModal, closeTelegramModal }}>
            {children}
        </TelegramModalContext.Provider>
    );
};

export const useTelegramModal = () => {
    const context = useContext(TelegramModalContext);
    if (!context) {
        throw new Error('useTelegramModal must be used within a TelegramModalProvider');
    }
    return context;
};
